export default "__VITE_ASSET__2f64905c__"